export {}

/**
 * Tenant configuration utilities.
 * La configuración real de tenants se carga dinámicamente desde /tenants.json
 * a través de TenantContext. Este archivo solo provee funciones de utilidad.
 */

function toValidCompanyId(raw: unknown): number | null {
  const value = Number(String(raw ?? "").trim())
  return Number.isInteger(value) && value > 0 ? value : null
}

function getEnvCompanyId(): number | null {
  return toValidCompanyId(import.meta.env.VITE_ODOO_COMPANY_ID)
}

/**
 * Retorna el basename del router. En este CRM no usamos sub-paths.
 */
export function getRouterBasename(): string {
  return ""
}

/**
 * Retorna el company ID configurado en el .env, si existe.
 */
export function getTenantCompanyId(): number | null {
  return getEnvCompanyId()
}

/**
 * Retorna el slug del tenant basado en el hostname.
 */
export function getTenantSlug(): string | null {
  if (typeof window === "undefined") return null
  const hostname = window.location.hostname
  const slug = hostname.split('.')[0]
  return slug !== 'localhost' && slug !== '127' ? slug : null
}

/**
 * No se usa en este proyecto - la configuración de branding
 * se maneja completamente a través de TenantContext.
 */
export function getTenantBranding() {
  console.warn("getTenantBranding() está deprecated - usa useTenant() de TenantContext")
  return {
    name: "CRM",
    primaryColor: "#2E5090",
    secondaryColor: "#40C4C7",
    logoMenu: "",
    logoMenuSm: "",
    logoLogin: "",
    logoBgLogin: "",
  }
}

/**
 * Agrega el basename del tenant a una ruta (no usado en este proyecto).
 */
export function withTenantBasename(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`
  return normalized
}

/**
 * Remueve el basename del tenant de una ruta (no usado en este proyecto).
 */
export function stripTenantBasename(pathname: string): string {
  return pathname || "/"
}

/**
 * Retorna una clave de storage con prefijo de tenant si aplica.
 */
export function getTenantStorageKey(baseKey: string): string {
  const slug = getTenantSlug()
  if (!slug) return baseKey
  return `${slug}:${baseKey}`
}
